<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>A Casa de Carnes Mineira</h2>
          <p>
            Na cidade de Anápolis (GO), <strong>José Batista Sobrinho</strong>,
            junto de seu irmão Juvensor, planta a semente que dá origem à
            <strong>JBS</strong>. Em um pequeno açougue, a Casa de Carnes
            Mineira, eles erguem os alicerces que representam a Cultura e os
            Valores da Companhia.
          </p>
          <img
            src="../assets/img/1953/1953-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--image">
          <a
            href="https://acervo.estadao.com.br/publicados/1953/02/27/g/19530227-23864-nac-0033-sci-11-not-heehkwe.jpg"
            target="_blank"
            class="fistItem"
          >
            <img src="../assets/img/1953/1953-2.jpg" alt="" />
          </a>
          <a
            href="https://acervo.estadao.com.br/publicados/1958/04/09/g/19580409-25439-nac-0018-999-18-not-pwaxehs.jpg"
            target="_blank"
          >
            <img src="../assets/img/1953/1953-3.png" alt="" />
          </a>
          <a
            href="https://acervo.estadao.com.br/publicados/1959/08/16/g/19590816-25857-nac-0027-999-27-not-apgpsws.jpg"
            target="_blank"
            class="span2"
          >
            <img src="../assets/img/1953/1953-4.png" alt="" />
          </a>
          <a
            href="https://acervo.estadao.com.br/publicados/1959/02/22/g/19590222-25709-nac-0026-999-26-not-kkgxqps.jpg"
            target="_blank"
            class="span2"
          >
            <img src="../assets/img/1953/1953-5.png" alt="" />
          </a>
          <a
            href="https://acervo.estadao.com.br/publicados/1956/04/15/g/19560415-24831-nac-0019-999-19-not-exaaewh.jpg"
            target="_blank"
            class="span2"
          >
            <img src="../assets/img/1953/1953-6.png" alt="" />
          </a>
          <a
            href="https://acervo.estadao.com.br/publicados/1956/04/15/g/19560415-24831-nac-0019-999-19-not-exaaewh.jpg"
            target="_blank"
          >
            <img src="../assets/img/1953/1953-7.png" alt="" />
          </a>

          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <div class="formato__video" @click.prevent="videoModal = !videoModal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="95"
              height="99"
              viewBox="0 0 95 99"
              fill="none"
            >
              <g clip-path="url(#clip0_152_330)">
                <path
                  d="M35.6071 70.9448C35.036 70.9448 34.4648 70.8013 33.9398 70.5085C32.8956 69.9287 32.2783 68.8896 32.2783 67.73V31.4424C32.2783 30.2828 32.9014 29.2437 33.9398 28.6639C34.984 28.084 36.2244 28.084 37.2686 28.6639L69.841 46.8105C70.8852 47.3903 71.5025 48.4294 71.5025 49.5891C71.5025 50.7487 70.8795 51.7878 69.841 52.3676L37.2686 70.5143C36.7494 70.807 36.1782 70.9506 35.6071 70.9506V70.9448Z"
                  fill="#FD2845"
                />
              </g>
              <defs>
                <clipPath id="clip0_152_330">
                  <rect width="95" height="99" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span></span>
          </div>
          <h2>Urbanização, industrialização e supermercados</h2>
          <p>
            Na década de 50, o Brasil passava por um processo de migração do
            campo para a cidade e de industrialização. Cada vez mais os
            brasileiros precisavam fazer refeições fora de casa e buscavam
            facilidades na hora de comprar, cozinhar e consumir alimentos. Foi
            nessa época que surgiram no Brasil os primeiros supermercados, em
            substituição às feiras e aos mercados públicos, como aponta o
            professor Fábio Bitelli, do Senac.
          </p>
          <blockquote>
            “Inconcebível que um país (...) como o nosso mal produza carne para
            o consumo interno.”
          </blockquote>
          <p>
            O mercado brasileiro de carne bovina ainda era incipiente e a
            pecuária engatinhava no País. Em notícia de 1953, o
            <strong>Estadão</strong> dizia: “<i
              >é inconcebível que um País com tantas possibilidades pecuárias
              como o nosso mal produza carne para o consumo interno</i
            >”. Na época, o Brasil tinha cerca de 55 milhões de habitantes,
            segundo o IBGE.
          </p>
          <a
            href="https://acervo.estadao.com.br/publicados/1955/07/06/g/19550706-24590-nac-0001-999-1-not-kaqxshg.jpg"
            target="_blank"
            class="negativo"
          >
            <img src="../assets/img/1953/1953-8.jpg" alt="" />
          </a>
        </div>
      </div>
    </div>
    <Transition>
      <div
        :class="['formato__video__modal', videoModal ? 'active' : '']"
        v-if="videoModal"
      >
        <div class="closemodal" @click.prevent="videoModal = !videoModal"></div>
        <button @click.prevent="videoModal = !videoModal">Fechar</button>
        <div class="container">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/rB2SS_cpo8M?si=D3apWiS_VJY7DbfX"
            title="JBS comemora 70 anos"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </Transition>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
      videoModal: false,
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require('@/assets/img/1953/1953-1-full.jpg'),
          title:
            '1953 - Casa de Carnes Mineira, em Anápolis (GO), onde José Batista Sobrinho, o sr. “Zé Mineiro”, deu início ao que é a JBS hoje.',
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  //position: relative;
  //overflow: hidden;

  a {
    display: block;
  }

  &__video {
    max-width: 95px;
    margin: 0px auto 50px;
    position: relative;
    cursor: pointer;
    @include media('<=desktop') {
      top: initial;
      margin-top: 30px;
    }

    &__modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      opacity: 0;
      z-index: -1;
      visibility: hidden;
      transition: visibility 0.3s linear, opacity 0.3s linear;
      &.active {
        opacity: 1;
        z-index: 9999;
        visibility: visible;
      }

      .closemodal {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: -1;
      }
      .container {
        position: relative;
        width: 100%;
        overflow: hidden;
        max-width: 900px;
      }
      iframe {
        width: 900px;
        height: 500px;
        @include media('<=desktop') {
          width: 350px;
          height: 250px;
          margin: 0 auto;
          display: block;
        }
      }

      button {
        background: none;
        border: none;
        color: color(cWhite);
        font-family: font(primary);
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 700;
        line-height: 135%; /* 0.84375rem */
        text-transform: uppercase;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        position: absolute;
        right: 55px;
        top: 80px;

        &:hover {
          color: color(cBlue);
        }

        &::before {
          content: '\e902';
          font-family: 'icomoon' !important;
          display: block;
          text-align: left;
          margin-block: 0.5rem;
          font-size: 0.8rem;
        }
      }
    }
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    span {
      width: 95px;
      height: 95px;
      background: url('../assets/img/text.png') center center no-repeat;
      background-size: cover;
      animation: rotateText 15s linear infinite;
      display: block;
    }
    .rotate {
      animation: rotateText 8s linear infinite;
    }
  }
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 370px 351px 380px;
    gap: 10px;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        display: grid;
        grid-template-columns: 188px 1fr;
        max-height: 674px;
        gap: 10px;
        padding: 0;
        margin-left: 60px;
        row-gap: 0;
        @include media('<=desktop') {
          margin-left: 0;
          padding: 0 20px;
        }
        a {
          &:nth-child(1) {
            height: 237px;
          }
          &:nth-child(3) {
            height: 47px;
          }
          &:nth-child(4) {
            height: 45px;
          }
          &:nth-child(5) {
            height: 45px;
          }
          &:nth-child(6) {
            height: 200px;
          }
        }
        .span2 {
          grid-column: span 2;
        }
        .fistItem {
        }
        .negativo {
          margin-left: -90px;
          margin-top: auto;
        }

        span {
          position: absolute;
          right: -13px;
          bottom: 140px;
          width: 65px;
          color: color(cWhite);
          @include media('<=desktop') {
            color: color(cBlue4);
            right: 20px;
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
            @include media('<=desktop') {
              color: color(cWhite);
              background: color(cBlue4);
            }
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media('>desktop') {
          margin-left: 40px;
        }
        a {
          margin-top: 40px;
          margin-left: -100px;
          @include media('<=desktop') {
            margin: 20px 0 0;
          }
        }

        @include media('<=desktop') {
          background: color(cBlue4);
          margin: 0;
          padding: 20px;
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
        }
      }
    }
    @include media('>desktop') {
      &::after {
        content: '';
        background: color(cBlue4);
        width: 45%;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        z-index: -1;
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
}
@keyframes rotateText {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
